<script>
    export default {
        props: [
            'route',
            'locale',
            'consultantUsername',
            'mainYearStart',
            'mainWeekStart',
            'mainYearEnd',
            'mainWeekEnd',
            'compareYearStart',
            'compareWeekStart',
            'compareYearEnd',
            'compareWeekEnd',
            'cacheKey',
            'initConsultantLevel',
            'initUserId',
            'stat',
        ],
        data() {
            return {
                result: {
                    mainTotal: 0,
                    percentage: 0,
                },
                formatter: null,
                userId: this.initUserId,
            }
        },
        created() {
            this.formatter = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        mounted() {
            let that = this;
            this.params = {
                consultantUsername: this.consultantUsername,
                cacheKey: 'd_r_f_d_w_' + this.initUserId + '_' + this.consultantLevel,
                mainYearStart: this.mainYearStart,
                mainWeekStart: this.mainWeekStart,
                mainYearEnd: this.mainYearEnd,
                mainWeekEnd: this.mainWeekEnd,
                compareYearStart: this.compareYearStart,
                compareWeekStart: this.compareWeekStart,
                compareYearEnd: this.compareYearEnd,
                compareWeekEnd: this.compareWeekEnd,
                consultantLevel: this.initConsultantLevel,
                stat: this.stat,
            };

            this.getData();

            Event.$on('downlineOrdersChanged', (username, userId) => {
                this.userId = userId || this.userId;
                this.params.cacheKey = 'd_r_f_d_w_' + this.initUserId + '_' + this.consultantLevel;
                this.params.consultantUsername = username|| this.consultantUsername;

                this.getData();
            });
            
            this.$nextTick().then(() => {
                $(document).on('change', '#revenue-downline__consultant-level', function () {
                    that.consultantLevel = $(this).val();
                    that.params.cacheKey = 'd_r_f_d_w_' + that.userId + '_' + that.consultantLevel;
                    that.params.consultantLevel = that.consultantLevel;

                    that.getData();
                });
            });
        },
        methods: {
            getData() {
                let params = this.params;
                $('.widget--statistic-box--revenue-downline .div-preloader').fadeIn();
                axios.get(this.route, {
                    params
                })
                    .then((res) => {
                        this.result = res.data.data;
                        $('.widget--statistic-box--revenue-downline .div-preloader').fadeOut();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/app/components/widgets/statistics/boxes/revenueDownline.vue